<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo cadastro
        </span>
      </h3>
    </div>
    <Form url="/pessoa/create" :pessoa="pessoa" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import PessoaData from "./PessoaData";
import { mapGetters } from "vuex";
import { onboardStore } from "../../../onboardStore";
import {
  SistemaMixin,
} from "@/modules/Application";

export default {
  name: "app-pessoa-create",
  data() {
    return {
      onboardStore,
      pessoa: new PessoaData({}),
    };
  },
  components: {
    Form,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
